export const ProblemIcon = () => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="problem"
    >
        <path
            clipRule="evenodd"
            d="m6.04021 1.52023-2.88889 3c-.15875.16486-.3841.24821-.61193.22634-.22782-.02188-.43319-.14659-.55767-.33865l-1.111114-1.71428 1.258734-.81585.59707.9212 2.23332-2.31922zm8.95979 1.97977h-8.00003v-1.5h8.00003zm-8.95979 3.27023-2.88889 3c-.15875.16486-.3841.24817-.61193.22634-.22782-.02188-.43319-.14659-.55767-.33865l-1.111114-1.71428 1.258724-.81585.59708.9212 2.23332-2.31922zm8.95979 1.97977h-8.00003v-1.5h8.00003zm-8.95979 3.2702-2.88889 3c-.15875.1649-.3841.2482-.61193.2264-.22782-.0219-.43319-.1466-.55767-.3387l-1.111115-1.7143 1.258725-.8158.59708.9212 2.23332-2.3192zm8.95979 1.9798h-8.00003v-1.5h8.00003z"
            fill="#bf63f3"
            fillRule="evenodd"
        />
    </svg>
);
